<template>
	<div class="slidebar">
		<el-row class="tac">
			<el-col>
				<el-menu
					class="el-menu-vertical-demo"
					@open="handleOpen"
					@close="handleClose"
					background-color="#171f2c"
					text-color="#fff"
					active-text-color="#ffd04b"
				>
					<el-submenu index="1">
						<template slot="title">
							<i class="el-icon-house"></i>
							<span><router-link to="/" active-class="link-active">首页</router-link></span>
						</template>
					</el-submenu>
					<el-menu-item index="2">
						<template slot="title">
							<i class="el-icon-menu"></i>
							<span><a href="/#/receipt" class="link">入荷指示列表</a></span>
						</template>
					</el-menu-item>
				</el-menu>
			</el-col>
		</el-row>
	</div>
</template>

<script>
export default {
	name: 'slidebar',
	methods: {
		handleOpen() {

		},
		handleClose() {

		}
	}
};
</script>

<style>
	.slidebar {
		width: 240px;
		position: fixed;
		top: 64px;
		left: 0;
		z-index: 99;
		text-align: left;
		height: 100%;
	}
	.el-row, .el-col, .el-menu {
		height: 100%;
	}
	.link-active, .link {
		color: #ffffff;
		text-decoration: none;
	}
</style>


